<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Correos de Eventos",
            items: [
                {
                    text: "Configuración",
                    href: "/"
                },
                {
                    text: "Correos de Eventos",
                    active: true
                }
            ],
            logs: [],
            stats: {
                total: 0,
                enviados: 0,
                fallidos: 0,
                con_error: 0,
            },
            tipos: [],
            estados: [],
            loading: false,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 50, 100],
            totalRows: 0,
            filtros: {
                search: '',
                estado: '',
                tipo: '',
                fecha_desde: '',
                fecha_hasta: '',
            },
            detalleLog: null,
        };
    },
    computed: {
        esAdmin() {
            return !!(this.user && this.user.rol === 'Admin');
        },
        totalPages() {
            return Math.ceil(this.totalRows / this.perPage) || 1;
        },
    },
    methods: {
        cargarLogs(page = this.currentPage) {
            if (!this.esAdmin) {
                this.loading = false;
                return;
            }

            this.loading = true;
            this.currentPage = page;

            axios.get('/api/email_logs_eventos', {
                params: {
                    page: this.currentPage,
                    per_page: this.perPage,
                    search: this.filtros.search,
                    estado: this.filtros.estado,
                    tipo: this.filtros.tipo,
                    fecha_desde: this.filtros.fecha_desde,
                    fecha_hasta: this.filtros.fecha_hasta,
                }
            }).then((res) => {
                const payload = res.data || {};
                const paginated = payload.logs || {};
                this.logs = Array.isArray(paginated.data) ? paginated.data : [];
                this.totalRows = Number(paginated.total || 0);
                this.currentPage = Number(paginated.current_page || 1);
                this.perPage = Number(paginated.per_page || this.perPage);
                this.stats = payload.stats || this.stats;
                this.tipos = Array.isArray(payload.tipos) ? payload.tipos : [];
                this.estados = Array.isArray(payload.estados) ? payload.estados : [];
            }).catch((error) => {
                console.error('Error al cargar email logs de eventos', error);
                this.logs = [];
                this.totalRows = 0;
            }).finally(() => {
                this.loading = false;
            });
        },
        limpiarFiltros() {
            this.filtros = {
                search: '',
                estado: '',
                tipo: '',
                fecha_desde: '',
                fecha_hasta: '',
            };
            this.cargarLogs(1);
        },
        badgeEstado(estado) {
            if (estado === 'enviado') return 'success';
            if (estado === 'fallido') return 'danger';
            if (estado === 'pendiente') return 'warning';
            return 'secondary';
        },
        formatFecha(fecha) {
            if (!fecha) return '-';
            return new Date(fecha).toLocaleString('es-CL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
        formatLista(valor) {
            if (!valor) return '-';
            if (Array.isArray(valor)) return valor.join(', ');
            return valor;
        },
        verDetalle(log) {
            this.detalleLog = log;
            this.$refs.modalDetalle.show();
        },
        irEvento(log) {
            if (!log || !log.evento_codigo) return;
            localStorage.setItem('evento_codigo', log.evento_codigo);
            window.location.href = '/web/configuracion/eventos';
        },
    },
    watch: {
        perPage() {
            this.cargarLogs(1);
        }
    },
    created() {
        if (!this.esAdmin) {
            window.location.href = '/';
            return;
        }
        this.cargarLogs(1);
    }
};
</script>

<template>
    <Layout>
        <div v-if="!esAdmin"></div>
        <template v-else>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-md-3 col-sm-6">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <p class="text-muted mb-2">Total registros</p>
                        <h4 class="mb-0">{{ stats.total }}</h4>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <p class="text-muted mb-2">Enviados</p>
                        <h4 class="mb-0 text-success">{{ stats.enviados }}</h4>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <p class="text-muted mb-2">Fallidos</p>
                        <h4 class="mb-0 text-danger">{{ stats.fallidos }}</h4>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <p class="text-muted mb-2">Con error</p>
                        <h4 class="mb-0 text-warning">{{ stats.con_error }}</h4>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <label>Buscar</label>
                        <b-form-input v-model="filtros.search" placeholder="Código, asunto, destinatario, error..."></b-form-input>
                    </div>
                    <div class="col-md-2">
                        <label>Estado</label>
                        <b-form-select v-model="filtros.estado">
                            <option value="">Todos</option>
                            <option v-for="estado in estados" :key="estado" :value="estado">{{ estado }}</option>
                        </b-form-select>
                    </div>
                    <div class="col-md-2">
                        <label>Tipo</label>
                        <b-form-select v-model="filtros.tipo">
                            <option value="">Todos</option>
                            <option v-for="tipo in tipos" :key="tipo" :value="tipo">{{ tipo }}</option>
                        </b-form-select>
                    </div>
                    <div class="col-md-2">
                        <label>Desde</label>
                        <b-form-input v-model="filtros.fecha_desde" type="date"></b-form-input>
                    </div>
                    <div class="col-md-2">
                        <label>Hasta</label>
                        <b-form-input v-model="filtros.fecha_hasta" type="date"></b-form-input>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="d-inline-flex align-items-center mb-0">
                            Mostrar&nbsp;
                            <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                        </label>
                    </div>
                    <div class="col-md-6 text-right">
                        <b-button variant="primary" class="mr-2" @click="cargarLogs(1)" :disabled="loading">
                            {{ loading ? 'Cargando...' : 'Aplicar filtros' }}
                        </b-button>
                        <b-button variant="secondary" @click="limpiarFiltros" :disabled="loading">Limpiar</b-button>
                    </div>
                </div>

                <div class="table-responsive mt-4">
                    <table class="table table-hover table-bordered align-middle">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Evento</th>
                                <th>Actividad</th>
                                <th>Tipo</th>
                                <th>Estado</th>
                                <th>Destinatarios</th>
                                <th>Asunto</th>
                                <th>Enviado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!loading && logs.length === 0">
                                <td colspan="9" class="text-center text-muted">No hay registros para los filtros seleccionados.</td>
                            </tr>
                            <tr v-for="log in logs" :key="log.id">
                                <td>{{ log.id }}</td>
                                <td>{{ log.evento_codigo || '-' }}</td>
                                <td>{{ log.evento_nombre || '-' }}</td>
                                <td>{{ log.tipo || '-' }}</td>
                                <td>
                                    <span class="badge" :class="`badge-${badgeEstado(log.estado)}`">{{ log.estado || '-' }}</span>
                                </td>
                                <td class="text-break">{{ formatLista(log.destinatarios) }}</td>
                                <td class="text-break">{{ log.subject || '-' }}</td>
                                <td>{{ formatFecha(log.enviado_en || log.created_at) }}</td>
                                <td>
                                    <b-button size="sm" variant="primary" class="mr-2" @click="verDetalle(log)">Detalle</b-button>
                                    <b-button size="sm" variant="outline-secondary" @click="irEvento(log)">Ver evento</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-3">
                    <div class="col-md-6 text-muted">
                        Total: {{ totalRows }} registros
                    </div>
                    <div class="col-md-6 d-flex justify-content-end">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            @change="cargarLogs"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="modalDetalle" title="Detalle del correo" size="lg" hide-footer>
            <div v-if="detalleLog">
                <div class="row mb-3">
                    <div class="col-md-6"><strong>ID:</strong> {{ detalleLog.id }}</div>
                    <div class="col-md-6"><strong>Evento:</strong> {{ detalleLog.evento_codigo || '-' }}</div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><strong>Actividad:</strong> {{ detalleLog.evento_nombre || '-' }}</div>
                    <div class="col-md-6"><strong>Tipo:</strong> {{ detalleLog.tipo || '-' }}</div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><strong>Estado:</strong> {{ detalleLog.estado || '-' }}</div>
                    <div class="col-md-6"><strong>Enviado:</strong> {{ formatFecha(detalleLog.enviado_en || detalleLog.created_at) }}</div>
                </div>
                <div class="mb-3"><strong>Asunto:</strong><div class="text-break">{{ detalleLog.subject || '-' }}</div></div>
                <div class="mb-3"><strong>Destinatarios:</strong><div class="text-break">{{ formatLista(detalleLog.destinatarios) }}</div></div>
                <div class="mb-3"><strong>CC:</strong><div class="text-break">{{ formatLista(detalleLog.cc) }}</div></div>
                <div class="mb-3"><strong>Correo colegio:</strong><div class="text-break">{{ detalleLog.correo_colegio || '-' }}</div></div>
                <div class="mb-3"><strong>Correo colegio 2:</strong><div class="text-break">{{ detalleLog.correo_colegio_2 || '-' }}</div></div>
                <div class="mb-3"><strong>RBD colegio:</strong><div class="text-break">{{ detalleLog.rbd_colegio || '-' }}</div></div>
                <div class="mb-3"><strong>Error:</strong><div class="text-break" style="white-space: pre-wrap;">{{ detalleLog.error_message || '-' }}</div></div>
                <div class="text-right">
                    <b-button variant="secondary" @click="$refs.modalDetalle.hide()">Cerrar</b-button>
                </div>
            </div>
        </b-modal>
        </template>
    </Layout>
</template>
